"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Batcher = void 0;
class Batcher {
    constructor(options) {
        this.options = options;
        this.items = [];
        this.invoking = false;
    }
    queue(item) {
        if (!this.invoking && this.items.length === 0) {
            setTimeout(async () => {
                this.execute();
            }, this.options.timeout);
        }
        this.items.push(item);
    }
    async execute() {
        this.invoking = true;
        const items = [...this.items];
        this.items = [];
        await this.options.invoke(items);
        this.invoking = false;
        // queue up another execution immediately
        if (this.items.length > 0) {
            this.execute();
        }
    }
}
exports.Batcher = Batcher;
